export function isExactMemberRequestCurrent(current, request, cancelled = false) {
  return !cancelled && Boolean(request?.subject) &&
    current?.identityKey === request.identityKey &&
    current?.clubCode === request.clubCode &&
    current?.subject === request.subject
}
